export const REQUEST_CASE_PRICE = "REQUEST_CASE_PRICE";
export interface RequestCasePrice {
  type: typeof REQUEST_CASE_PRICE;
  priceId: string;
}
